import { multicastChannel } from "redux-saga";
import actions from "./actions";

const initState = {
    addChatrBulkActivationLoading: false,
    addChatrBulkActivationError: null,
    addChatrBulkActivationMessage: null,

    chatrActivationLoading: false,
    chatrActivationError: null,
    chatrActivationResult: [],

    bulkChatrResultByBatchID: [],
    bulkChatrResultByBatchIDLoading: false,
    bulkChatrResultByBatchIDError: null,
};

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.RESET_CHATR_MESSAGES:
            return {
                ...state,
                addChatrBulkActivationMessage: null,
                addChatrBulkActivationError: null,
            };
        case actions.ADD_CHATR_BULK_ACTIVATION:
            return {
                ...state,
                addChatrBulkActivationLoading: true,
                addChatrBulkActivationError: null,
                addChatrBulkActivationMessage: null,
            };
        case actions.ADD_CHATR_BULK_ACTIVATION_SUCCESS:
            return {
                ...state,
                addChatrBulkActivationLoading: false,
                addChatrBulkActivationError: null,
                addChatrBulkActivationMessage: action.payload.message,
            };
        case actions.ADD_CHATR_BULK_ACTIVATION_FAILED:
            return {
                ...state,
                addChatrBulkActivationLoading: false,
                addChatrBulkActivationError: action.payload.error,
                addChatrBulkActivationMessage: null,
            };
        case actions.GET_CHATR_ACTIVATION_REQUEST_LIST:
            return {
                ...state,
                chatrActivationLoading: true,
                chatrActivationResult: [],
                chatrActivationError: null,
            };
        case actions.GET_CHATR_ACTIVATION_REQUEST_LIST_SUCCESSFUL:
            return {
                ...state,
                chatrActivationLoading: false,
                chatrActivationResult: action.payload.data,
                chatrActivationError: null,
            };
        case actions.GET_CHATR_ACTIVATION_REQUEST_LIST_FAILED:
            return {
                ...state,
                chatrActivationError: action.payload.activationError,
                chatrActivationLoading: false,
                chatrActivationResult: []
            };
        case actions.RESET_CHATR_VALIDATE_MESSAGE:
            return {
                ...state,
                addChatrBulkActivationMessage: null,
                addChatrBulkActivationError: null,
            };

        case actions.GET_CHATR_BATCHTRANSACTIONBYID_REQUEST:
            return {
                ...state,
                bulkChatrResultByBatchIDLoading: true,
                bulkChatrResultByBatchID: null,
                bulkChatrResultByBatchIDError: action.error,
            };
        case actions.GET_CHATR_BATCHTRANSACTIONBYID_REQUEST_FAILED:
            return {
                ...state,
                bulkChatrResultByBatchIDLoading: false,
                bulkChatrResultByBatchID: action.payload.result,
                bulkChatrResultByBatchIDError: null,
            };
        case actions.GET_CHATR_BATCHTRANSACTIONBYID_REQUEST_FAILED:
            return {
                ...state,
                bulkChatrResultByBatchIDLoading: false,
                bulkChatrResultByBatchID: null,
                bulkChatrResultByBatchIDError: action.error,
            };

        default:
            return state;
    }
}
